import styled from "styled-components";

export const NavList = styled.ul`
  gap: 5px;
  width: 100%;
  display: flex;
  padding: 0 16px;
  align-items: center;
  justify-content: space-between;
`;
